<template>
    <div class="header">
        <div class="plac">
            <div class="nav">
                <div @click="home" class="tohome">
                    <i class="logo"></i>
                </div>
                <nav class="links">
                    <router-link to="/" class="link-item">首页</router-link>
                    <router-link to="/about" class="link-item">
                        关于博牛
                        <div class="sec-menu">
                            <span @click="jump('about', 0)">公司概况</span>
                            <span @click="jump('about', 1)">核心团队</span>
                            <span @click="jump('about', 2)">荣誉资质</span>
                            <span @click="jump('about', 3)">博牛动态</span>
                        </div>
                    </router-link>
                    <router-link to="/investment" class="link-item">
                        博牛投资
                        <div class="sec-menu">
                            <span @click="jump('investment', 0)">投资理念</span>
                            <span @click="jump('investment', 1)">投资范畴</span>
                            <span @click="jump('investment', 2)">风控体系</span>
                        </div>
                    </router-link>
                    <router-link to="/featured" class="link-item">基金精选
                    </router-link>
                    <router-link to="/news" class="link-item">
                        新闻公告
                    </router-link>
                    <router-link to="/contact" class="link-item">联系我们</router-link>
                </nav>
                <div class="user">
                    <div v-show="login_number">
                        <span @click="auth">
                            <i class="i-user" v-if="!$store.state.score"></i>
                            <i class="i-auth-user" v-else></i>
                            {{login_number}}
                        </span>
                        <div class="user-tool">
                            <span @click="user_center">
                                <i class="icon i-person"></i>
                                个人中心
                            </span>
                            <span @click="logout">
                                <i class="icon i-logout"></i>
                                退出
                            </span>
                        </div>
                    </div>
                    <div v-show="!login_number" @click="showPop = 'regist'">
                        <span>注册</span>
                        <span>登录</span>
                    </div>
                </div>
            </div>
        </div>
        <pop v-if="showPop == 'regist'"></pop>
        <auth v-if="showPop == 'auth'"></auth>
    </div>
</template>

<script>
import {post} from '@/http.js'
export default {
    components: {
        pop: () => import('../pop/regist.vue'),
        auth: () => import('../pop/auth.vue')
    },
    data() {
        return {
            showPop: false,
            timer: ''
        }
    },
    inject: ['reload'],
    computed: {
        login_number() {
            return this.$store.state.login_phone;
        },
        gpop() {
            return this.$store.state.pop
        },
        path() {
            return this.$route.path
        }
    },
    methods: {
        home() {
            this.$router.push('/');
        },
        auth() {
            this.$root.$emit('openAuth');
        },
        user_center() {
            this.$router.push('/user-center');
        },
        logout() {
            post('user/logout').then(() => {
                this.$store.commit('logout');
                this.$router.push('/');
                if (this.$route.path == '/') {
                    this.reload();
                }
            })
        },
        jump(route, tab) {
            if(this.$route.name == route) {
                this.$root.$emit('select', tab)
                return
            }
            this.$router.push({
                name: route,
                params: {
                    tab: tab
                }
            })
        }

    },
    created() {
        this.showPop = this.gpop
        this.$root.$on('closePop', () => {
            let type = this.showPop
            this.showPop = false;
            if(type == 'auth' && this.path == '/fund') {
                this.timer = setTimeout(() => {
                    this.showPop = 'auth'
                }, 15000)
            }
        });
        this.$root.$on('login', () => {
            this.showPop = 'regist'
        })
        this.$root.$on('openAuth', () => {
            if(this.$store.state.login_phone && !this.$store.state.score) {
                this.showPop = 'auth';
            } else if (!this.$store.state.login_phone) {
                this.showPop = 'regist'
            }
        })
    },
    watch: {
        gpop(v) {
            this.showPop = v
        },
        showPop(v) {
            this.$store.commit('changePop', v)
        },
        path(v) {
            if(v != '/fund') {
                clearTimeout(this.timer)
            }
        }
    }
}
</script>